import { render, staticRenderFns } from "./StockVPTView.vue?vue&type=template&id=4b4d2a9d&scoped=true"
import script from "./StockVPTView.vue?vue&type=script&lang=js"
export * from "./StockVPTView.vue?vue&type=script&lang=js"
import style0 from "./StockVPTView.vue?vue&type=style&index=0&id=4b4d2a9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4d2a9d",
  null
  
)

export default component.exports